import React, { useState, useEffect } from "react";
import TopNav from "../global-components/top_nav";
import axios from "axios";
import requests from "../../utils/Requests";
import CommonBanner from "../global-components/common_banner";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Footer from "../global-components/footer";

const MealsTypeList = () => {
  const publicUrl = process.env.PUBLIC_URL + "/";
  const isLoggedIn = sessionStorage.getItem("isLoggedIn");
  const [mealsList, setMealsList] = useState([]);

  useEffect(() => {
    getMealsTypeList();
  }, []);

  const getMealsTypeList = async () => {
    try {
      const res = await axios.post(requests.getMealTypeActiveList, {
        mealOptionsId: 1,
      });

      console.log(res.data);
      setMealsList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <TopNav />
      <CommonBanner title="Meals" imgUrl="aboutUs.jpeg" />

      <div className="about-section pd-top-80">
        <div className="container">
          <div className="row">
            {mealsList?.map((item, index) => (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={index}>
                <div className="card h-100 shadow-sm text-center border-0">
                  <img
                    src={requests.imgpath + item.thumbNailImage}
                    alt={item.attName}
                    className="card-img-top"
                    style={{
                      height: "200px",
                      objectFit: "cover",
                      borderTopLeftRadius: "0.5rem",
                      borderTopRightRadius: "0.5rem",
                    }}
                  />
                  <div className="card-body">
                    <p className="text-muted mb-1">
                      <img
                        src={publicUrl + "assets/img/icons/1.png"}
                        alt="city icon"
                        style={{ width: "16px", marginRight: "5px" }}
                      />
                      {item?.mealHotel?.address}
                    </p>
                    <h5 className="card-title" style={{ color: "#071c55" }}>
                      <Link to={`mealsdetailsandbook/${item.mealTypeId}`}>
                        {item?.mealHotel?.hotelName} - {item.mealName}
                      </Link>
                    </h5>

                    {isLoggedIn === "yes" && (
                      <div className="d-flex justify-content-between mt-3">
                        <div>
                          <small>Adult Price</small>
                          <h6 className="mb-0">{item.adultPrice} AED</h6>
                        </div>
                        <div>
                          <small>Child Price</small>
                          <h6 className="mb-0">{item.childPrice} AED</h6>
                        </div>
                      </div>
                    )}

                    <Link
                      className="btn btn-warning mt-3"
                      to={`mealsdetailsandbook/${item.mealTypeId}`}
                    >
                      Book Now <i className="fa fa-paper-plane ml-2" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
            {mealsList.length === 0 && (
              <div className="col-12 text-center">
                <p>No meals available at the moment.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MealsTypeList;
